import { createSlice } from '@reduxjs/toolkit';

let hideTimeoutId = null;

const alertSlice = createSlice({
  name: 'alert',
  initialState: {
    show: false,
    type: 'success',
    message: ''
  },
  reducers: {
    showAlert: (state, action) => {
      const { type, message } = action.payload;
      state.show = true;
      state.type = type;
      state.message = message;
    },
    hideAlert: (state) => {
      state.show = false;
      state.type = '';
      state.message = '';
    }
  }
});

const { showAlert: rawShowAlert, hideAlert } = alertSlice.actions;

const showAlert = (type, message, timeout = 5000) => (dispatch) => {
  if (hideTimeoutId) {
    clearTimeout(hideTimeoutId);
    hideTimeoutId = null;
  }

  dispatch(rawShowAlert({ type, message }));

  hideTimeoutId = setTimeout(() => {
    dispatch(hideAlert());
    hideTimeoutId = null;
  }, timeout);
};

export { showAlert, hideAlert };
export default alertSlice.reducer;